export default __webpack_public_path__ + "static/media/folclore-fantastico.8c295ab5.mp4";